import { SuklAdministrationRouteGridObject } from '@libs/types/src/list/object-type/sukl-administration-route.object';
import { GridInput } from '@it2go/data-grid';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { filterFrag } from '../types/filter.types';
import { suklAdministrationRouteFrag } from '../types/sukl-administration-route.types';

@Injectable({ providedIn: 'root' })
export class ListSuklAdministrationRouteService extends GqlServiceV2 {
    public getListSuklAdministrationRoutes(input: GridInput, frag = suklAdministrationRouteFrag) {
        return this.query<SuklAdministrationRouteGridObject>(
            `
                query($input: GridInput!) {
                    suklAdministrationRoute {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
